import React, { useContext, useEffect, useRef, useState } from "react";
import { professionalAction } from "../../_actions";
import { TableWanted } from "../Reports/Tables/wantedTable";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  message,
  Table,
} from "antd";
import { connect } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  BarChartOutlined,
  CloseCircleFilled,
  FilterOutlined,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";
import moment from "moment";
import { roleAction } from "../../_actions/roleby.action";
import { wantedHistoryAction } from "../../_actions/wanted_history.actions";
import { twoPlusAction } from "../../_actions/twoplus.actions";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
import { adminService } from "../../_services/admin.service";

const Wanted = (props) => {
  const { Option } = Select;
  console.log(" wnated props", props);
  const [condition, setCondition] = useState("पाहिजे");
  const [download, setDownload] = useState("excel");
  const [city, setCity] = useState(props?.user?.cityId);
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [criminalViewModel, setCriminalViewModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [total, setTotal] = useState(0);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [showList, setShowList] = useState("list");
  const [filter, setFilter] = useState(false);
  const [photoStatus, setPhotoStatus] = useState();
  const [isFilter, setIsFilter] = useState();

  const [cities, setCities] = useState([]);
  const [district, seDistrict] = useState([]);
  const [citySelected, SetCitySelected] = useState(false);

  const [selectCity, setSelectCity] = useState();
  const [selectDistrict, setSelectDistrict] = useState([]);
  const [advancedFilterPhoto, setAdvancedFilterPhoto] = useState("all");
  const [dataBackup, setDataBackup] = useState([]);
  const [photoCount, setPhotoCount] = useState(0);
  const [stationType, setStationType] = useState("crime");

  useEffect(() => {
    props.dispatch(professionalAction.getCity());
  }, []);

  const handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;

    let filtered = [];
    let total = 0;

    if (value === "yes") {
      filtered = dataBackup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = dataBackup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else if (value === "all") {
      total = dataBackup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      ).length;
    }

    setAdvancedFilterPhoto(value);
    if (value === "all") {
      setData(dataBackup);
      setTotal(dataBackup.length);
      setPhotoCount(total);
    } else {
      setData(filtered);
      setTotal(filtered.length);
      if (value === "yes") {
        setPhotoCount(filtered.length);
      } else {
        setPhotoCount(0);
      }
    }
  };

  const onCityChange = (value) => {
    SetCitySelected(true);
    setSelectCity(value);
    setSelectDistrict([]);
    setSelectDistrict([]);
    props.onCityChange(value, 1);
  };

  console.log("select city", selectCity, selectDistrict);
  useEffect(
    (res) => {
      if (
        props.professionals &&
        props.professionals.pc_cities &&
        props.professionals.pc_cities
      ) {
        setCities([...props.professionals.pc_cities]);
      }
    },
    [props.professionals],
  );

  useEffect(
    (res) => {
      if (props.professionals && props.professionals.basicDistricts) {
        seDistrict([...props.professionals.basicDistricts]);
      }
    },
    [props.professionals && props.professionals.basicDistricts],
  );

  const handleCondition = (viewType) => {
    setShowList(viewType);
    getdata(condition, viewType);
  };
  const getWanted = async (
    condition,
    search,
    selectDistricts,
    citySelect,
    photo_status,
  ) => {
    if (props?.user?.role === "2") {
      let temp;
      let city_ids = citySelect ? selectCity : city;
      temp = {
        condition:
          condition != "हिस्ट्रीशिटर" || condition != "गुंडा"
            ? condition
            : null,
        search: search ? search : "",
        photo_status: photo_status ? photo_status : "",
        selectDistrict: selectDistricts.length > 0 && selectDistricts,
        userId: props.user.id,
        gunda: condition === "गुंडा" && "1",
      };

      setLoading(true);

      try {
        const response = await wantedHistoryAction.getWantedHistory(temp);
        const data = await response.json();
        if (data.data.length > 0) {
          const finaldata = data.data.map((res, index) => ({
            ...res,
            photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
            index: index + 1,
          }));
          setData(finaldata);
          setDataBackup(finaldata);
          console.log("Fetched Data:", finaldata);
          setLoading(false);
          setTotal(finaldata.length);
          let totalPhotoCount = finaldata.reduce(
            (sum, res) =>
              sum +
              (res.photo !== null && res.photo !== "" && res.photo !== undefined
                ? 1
                : 0),
            0,
          );
          setPhotoCount(totalPhotoCount);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      let city_ids = selectCity;
      const temp = {
        condition:
          condition != "हिस्ट्रीशिटर" || condition != "गुंडा"
            ? condition
            : null,
        search: search ? search : "",
        photo_status: photo_status ? photo_status : "",
        selectDistrict: selectDistricts.length > 0 && selectDistricts,
        cityId: selectCity ? city_ids : props?.user.cityId,
        historySheeter: condition == "हिस्ट्रीशिटर" && "2",
        gunda: condition === "गुंडा" && "1",
      };
      try {
        const response =
          await wantedHistoryAction.getWantedHistoryListCityWise(temp);
        const data = await response.json();
        if (data.data.length > 0) {
          const finaldata = data.data.map((res, index) => ({
            ...res,
            photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
            index: index + 1,
          }));
          setData(finaldata);
          setDataBackup(finaldata);
          console.log("Fetched Data:", finaldata);
          setLoading(false);
          setTotal(finaldata.length);
          let totalPhotoCount = finaldata.reduce(
            (sum, res) =>
              sum +
              (res.photo !== null && res.photo !== "" && res.photo !== undefined
                ? 1
                : 0),
            0,
          );
          setPhotoCount(totalPhotoCount);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const getConditionWantedByRole = async (condition, photoStatus) => {
    let temp = {
      district:
        props?.user?.role === "2"
          ? [props?.user.districtId]
          : props?.user?.map_districtId,
      condition:
        condition != "हिस्ट्रीशिटर" || condition != "गुंडा" ? condition : null,
      photo_status: photoStatus != "all" ? photoStatus : "",
      historySheeter: condition === "हिस्ट्रीशिटर" && "1",
      gunda: condition === "गुंडा" && "1",
    };
    setLoading(true);

    try {
      const response = await roleAction.getConditionWantedByRole(temp);
      const data = await response.json();
      if (data.data.length > 0) {
        const finaldata = data.data.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        console.log("Fetched Data:", finaldata);
        setLoading(false);
        setTotal(finaldata.length);
        let totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
        setPhotoCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (condition && showList) getdata(condition, showList);
  // }, [condition, showList]);

  const getWantedByAccusedDistrict = async (value, search, photo_status) => {
    setLoading(true);
    const temp = {
      districtId: props.user.districtId,
      condition: value,
      search: search ? search : "",
      photo_status: photo_status ? photo_status : "",
    };

    try {
      const response =
        await wantedHistoryAction.getWantedHistoryByAccusedDistrict(temp);
      const data = await response.json();
      if (data.data && data.data.length > 0) {
        const finaldata = data.data.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        setTotal(finaldata.length);
        const totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
        setDataBackup([]);
        setTotal(0);
        setPhotoCount(0);
      }
    } catch (error) {
      console.error("Error fetching accused district wanted list:", error);
    } finally {
      setLoading(false);
    }
  };

  const isCityAdminRole = ["4", "9", "10", "12"].includes(
    String(props.user.role),
  );

  const getWantedByAccusedCity = async (
    value,
    search,
    selectDistricts,
    citySelect,
    photo_status,
  ) => {
    setLoading(true);
    const temp = {
      condition: value,
      search: search ? search : "",
      photo_status: photo_status ? photo_status : "",
      selectDistrict: selectDistricts.length > 0 && selectDistricts,
      cityId: citySelect ? selectCity : props?.user.cityId,
    };

    try {
      const response =
        await wantedHistoryAction.getWantedHistoryByAccusedCity(temp);
      const data = await response.json();
      if (data.data && data.data.length > 0) {
        const finaldata = data.data.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        setTotal(finaldata.length);
        const totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
        setDataBackup([]);
        setTotal(0);
        setPhotoCount(0);
      }
    } catch (error) {
      console.error("Error fetching accused city wanted list:", error);
    } finally {
      setLoading(false);
    }
  };

  const getWantedByDistrict = async (value, photo_status) => {
    let temp;

    temp = {
      condition: condition,
      photo_status: photo_status && photo_status,
    };

    setLoading(true);
    const district = props.user.districtId;
    try {
      const response = await professionalAction.getWantedByDistrict(
        district,
        temp,
      );
      const data = await response.json();
      if (data.data.length > 0) {
        const finaldata = data.data.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        console.log("Fetched Data:", finaldata);
        setLoading(false);
        setTotal(finaldata.length);
        let totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTadipaarByPS = async (photo_status, searchText) => {
    let temp;

    temp = {
      district: props.user.districtId,
      photo_status: photo_status ? photo_status : "",
      searchText: searchText && searchText,
    };

    setLoading(true);

    professionalAction.getTadipaarByPS(temp).then((res) => {
      console.log("res", res.results);
      let criminal = res.results;
      if (criminal.length > 0) {
        const finaldata = criminal.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo[0] != "" ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        console.log("Fetched Data:", finaldata);
        setLoading(false);
        setTotal(finaldata.length);
        let totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
        setLoading(false);
      }
    });
  };
  console.log("props.user.role", props.user);
  // Fetch data whenever page or size changes

  const getTadipaarByCity = (
    search,
    selectDistricts,
    citySelect,
    photo_status,
  ) => {
    let temp;

    temp = {
      search: search ? search : "",
      cityId: citySelect ? selectCity : city,
      photo_status: photo_status ? photo_status : "",
      selectDistrict: selectDistricts.length > 0 && selectDistricts,
    };

    setLoading(true);

    professionalAction.getTadipaarByCity(temp).then((res) => {
      console.log("res", res.results);
      let criminal = res.results;
      if (criminal.length > 0) {
        const finaldata = criminal.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo[0] != "" ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        console.log("Fetched Data:", finaldata.length);
        setLoading(false);
        setTotal(finaldata.length);
        let totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
        setLoading(false);
      }
    });
  };

  const getTadipaarByRole = async (search, photo_status) => {
    let temp;
    temp = {
      district: props.user.map_districtId,
      search: search ? search : "",
      photo_status: photo_status ? photo_status : "",
    };

    setLoading(true);
    try {
      const response = await roleAction.getTadipaarByRole(temp);
      const data = await response.json();
      if (data.results.length > 0) {
        const finaldata = data.results.map((res, index) => ({
          ...res,
          photoPresent: res?.photo && res?.photo?.length > 0 ? "हो" : "नाही",
          index: index + 1,
        }));
        setData(finaldata);
        setDataBackup(finaldata);
        console.log("Fetched Data:", finaldata);
        setLoading(false);
        setTotal(finaldata.length);
        let totalPhotoCount = finaldata.reduce(
          (sum, res) =>
            sum +
            (res.photo !== null && res.photo !== "" && res.photo !== undefined
              ? 1
              : 0),
          0,
        );
        setPhotoCount(totalPhotoCount);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTadipaarCountByCity = (citySelected) => {
    setTotal();
    setLoading(true);
    const temp = {
      cityId: citySelected ? selectCity : city,
      selectDistrict: citySelected && selectDistrict,
    };
    professionalAction.getTadipaarCountByCity(temp).then((res) => {
      console.log("res", res.results);
      let criminal = res.results;
      if (criminal.length > 0) {
        setData(criminal);
        setDataBackup(criminal);
        setLoading(false);
        let totalCrimeCount = criminal.reduce(
          (sum, item) => sum + item.crimeCount,
          0,
        );
        setTotal(totalCrimeCount);
      } else {
        setData([]);
        setLoading(false);
      }
    });
  };

  const getTadipaarCountByRole = async () => {
    setTotal();
    setLoading(true);
    const temp = {
      district: props.user.map_districtId,
    };

    try {
      const response = await roleAction.getTadipaarCountByRole(temp);
      const data = await response.json();
      if (data.results.length > 0) {
        setData(data.results);
        setDataBackup(data.results);
        setLoading(false);
        let totalCrimeCount = data.results.reduce(
          (sum, item) => sum + item.crimeCount,
          0,
        );
        setTotal(totalCrimeCount);
        setLoading(false);
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getWantedCountByCity = async (citySelected, type = stationType) => {
    setTotal();
    setLoading(true);
    const temp = {
      cityId: citySelected ? selectCity : props.user?.cityId,
      condition: condition != "हिस्ट्रीशिटर" && condition,
      selectDistrict: citySelected && selectDistrict,
      historySheeter: condition === "हिस्ट्रीशिटर" && 2,
      stationType: type,
    };
    const response = await wantedHistoryAction.getWantedHistoryCount(temp);
    const data = await response.json();
    let criminal = data.results;
    if (criminal.length > 0) {
      setData(criminal);
      setDataBackup(criminal);
      setLoading(false);
      let totalCrimeCount = criminal.reduce(
        (sum, item) => sum + item.crimeCount,
        0,
      );
      setTotal(totalCrimeCount);
    } else {
      setData([]);
      setLoading(false);
    }
  };

  const getWantedCountByRole = async () => {
    try {
      setTotal();
      setLoading(true);
      const temp = {
        district: props?.user?.map_districtId,
        condition: condition != "हिस्ट्रीशिटर" && condition,
        historySheeter: condition === "हिस्ट्रीशिटर" && "1",
      };

      const response = await roleAction.getWantedCountByRole(temp);
      const data = await response.json();
      console.log("data", data);
      if (data.results.length > 0) {
        setData(data.results);
        setDataBackup(data.results);
        setLoading(false);
        let totalCrimeCount = data.results.reduce(
          (sum, item) => sum + item.crimeCount,
          0,
        );
        setTotal(totalCrimeCount);
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [searchText, setSerachText] = useState("");

  const getdata = (
    value = condition,
    viewType = showList,
    selectDistricts = selectDistrict,
    citySelect = citySelected,
    photo_status = photoStatus,
    search = searchText,
  ) => {
    console.log("props.user.role", props.user.role);
    console.log("viewType get data", viewType);
    setData([]);
    setDataBackup([]);
    setTotal();

    if (viewType === "count") {
      if (props.user.role === "4" || props.user.role === "12") {
        if (value === "तडीपार") {
          getTadipaarCountByCity(citySelect);
        }
        if (
          value === "पाहिजे" ||
          value === "फरार" ||
          value === "हिस्ट्रीशिटर"
        ) {
          getWantedCountByCity(citySelect);
        }
      }
      if (props.user.role === "9" || props.user.role === "10") {
        if (value === "तडीपार") {
          getTadipaarCountByRole();
        }
        if (
          value === "पाहिजे" ||
          value === "फरार" ||
          value === "हिस्ट्रीशिटर"
        ) {
          // getWantedCountByRole();
          getWantedCountByCity(citySelect);
        }
      }
    }

    if (viewType === "list") {
      if (props.user.role === "4" || props.user.role === "12") {
        if (value === "तडीपार") {
          getTadipaarByCity(search, selectDistricts, citySelect, photo_status);
        }
        if (
          stationType === "accused" &&
          (value === "पाहिजे" || value === "फरार")
        ) {
          getWantedByAccusedCity(
            value,
            search,
            selectDistricts,
            citySelect,
            photo_status,
          );
        } else if (
          value === "पाहिजे" ||
          value === "फरार" ||
          value === "हिस्ट्रीशिटर" ||
          value === "गुंडा"
        ) {
          getWanted(value, search, selectDistricts, citySelect, photo_status);
        }
      } else if (props.user.role === "2") {
        if (
          stationType === "accused" &&
          (value === "पाहिजे" || value === "फरार")
        ) {
          getWantedByAccusedDistrict(value, search, photo_status);
          return;
        }
        if (value === "तडीपार") {
          getTadipaarByPS(photo_status, search);
        }
        if (value === "पाहिजे" || value === "फरार") {
          getWanted(value, search, selectDistricts, citySelect, photo_status);
        }
        if (value === "हिस्ट्रीशिटर" || value === "गुंडा") {
          getConditionWantedByRole(value, photo_status);
        }
      } else if (props.user.role === "9" || props.user.role === "10") {
        if (value === "तडीपार") {
          getTadipaarByRole(search, photo_status);
        }
        if (
          stationType === "accused" &&
          (value === "पाहिजे" || value === "फरार")
        ) {
          getWantedByAccusedCity(
            value,
            search,
            selectDistricts,
            citySelect,
            photo_status,
          );
        } else if (
          value === "पाहिजे" ||
          value === "फरार" ||
          value === "हिस्ट्रीशिटर" ||
          value === "गुंडा"
        ) {
          // getConditionWantedByRole(value, photo_status);
          getWanted(value, search, selectDistricts, citySelect, photo_status);
        }
      }
    }
  };

  const onViewAccusedForm = (data) => {
    if (data) {
      props.dispatch(professionalAction.getCriminalsViewsByIdView(data));
      showCriminalViewModel();
    }
  };

  const showCriminalViewModel = () => {
    setCriminalViewModel(true);
  };

  const closeCriminalViewModel = () => {
    setCriminalViewModel(false);
  };

  const [form] = Form.useForm();
  const [formDownload] = Form.useForm();

  const getCityName = (id) => {
    console.log("props", props);
    const { pc_cities } = props && props;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  const [districtName, setDistrictName] = useState("");
  const getDistrictsid = (id) => {
    console.log("users id", props);
    professionalAction.getDistrictsid(props.user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      setDistrictName(tempData[0]?.DistrictName);
    });
  };

  useEffect(() => {
    if (props.user.role === "2") {
      getDistrictsid();
    }
  }, []);

  const download_csv = () => {
    const title =
      condition === "पाहिजे"
        ? t("required")
        : condition === "फरार"
          ? t("absconding")
          : condition === "हिस्ट्रीशिटर"
            ? t("history")
            : t("tadipar");

    const ReportTitle = `${title}_${t("report")}`;

    const arrData = Array.isArray(data) ? data : [];

    if (!arrData.length) {
      console.error("No data available to export.");
      return;
    }

    const file_name = `${ReportTitle}_${moment().format("DDMMMYYYY")}`;

    /* ------------------ DATA PREP ------------------ */
    let list =
      showList === "count"
        ? arrData.map((data, index) => ({
            "अ.क्र.": index + 1,
            [condition === "फरार"
              ? "पोलिस ठाणे (फरार)"
              : condition === "हिस्ट्रीशिटर"
                ? t("police_station_required1")
                : condition === "तडीपार"
                  ? t("police_station_action_by")
                  : t("police_station_required")]: data.districtName,
            [t("total")]: data.crimeCount,
          }))
        : condition !== "तडीपार"
          ? arrData.map((data, index) => {
              const whenToPatrolColumn =
                condition === "हिस्ट्रीशिटर"
                  ? t("history_sheeter_entry_date")
                  : condition === "फरार"
                    ? t("when_to_patrol_absconding")
                    : t("when_to_patrol");

              const item = {
                "अ.क्र.": index + 1,
                [t("police_station_required")]: data.policeSideNeed,
                [t("name_of_the_accused")]: data.name,
                [t("accused_police_station")]: data.districtName,
              };

              if (condition !== "हिस्ट्रीशिटर") {
                item[t("current_status")] =
                  data.current_condition || data.currentcondition;
              }

              item[whenToPatrolColumn] = data.date_from
                ? moment(data.date_from).format("DD/MM/YYYY")
                : moment(data.current_condition_date).format("DD/MM/YYYY");

              item[t("total_crimes")] = data.totalCrimeCount || data.gunhaCount;

              item["फोटो"] =
                data?.photo && data.photo.length > 0 ? "हो" : "नाही";

              return item;
            })
          : arrData.map((data, index) => {
              const today = moment().startOf("day");
              const dateFrom = data?.date_from ? moment(data.date_from) : null;
              const dateTo = data?.date_to ? moment(data.date_to) : null;

              let preventiveActionStatus = "-";

              if (dateFrom && dateTo) {
                if (today.isBetween(dateFrom, dateTo, "day", "[]")) {
                  preventiveActionStatus = t("ongoing");
                } else if (dateTo.isBefore(today, "day")) {
                  preventiveActionStatus = t("completed");
                }
              }

              return {
                "अ.क्र.": index + 1,

                "आरोपीचे नाव": data.name,

                "आरोपीचे पोलिस ठाणे": data.districtName,

                "एकुण गुन्हे": data.totalCrimeCount || data.gunhaCount,

                फोटो: data?.photo && data.photo.length > 0 ? "हो" : "नाही",
                "पोलिस स्टेशन(कारवाई करणारे)": data.action_taken_police_station,

                [t("preventive_action")]: data.preventiveActionName,
                [t("preventive_action_status")]: preventiveActionStatus,

                [t("start_date")]: data?.date_from
                  ? moment(data.date_from).format("DD-MM-YYYY")
                  : "-",

                [t("end_date")]: data?.date_to
                  ? moment(data.date_to).format("DD-MM-YYYY")
                  : "-",
                [t("area_of_tadipar")]: data?.tadipar_unit,
              };
            });

    const exportData = list.filter(Boolean);

    /* ------------------ EXCEL SETUP ------------------ */
    const ws = XLSX.utils.json_to_sheet(exportData, { origin: "A3" });

    const columnWidths = Object.keys(exportData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...exportData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));
    ws["!cols"] = columnWidths;

    /* ------------------ STYLES ------------------ */
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    /* ------------------ APPLY STYLES ------------------ */
    const HEADER_ROW = 2; // Excel row 3

    Object.keys(exportData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: HEADER_ROW, c: colIndex });
      if (ws[cellRef]) ws[cellRef].s = headerStyle;
    });

    exportData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + HEADER_ROW + 1,
          c: colIndex,
        });
        if (ws[cellRef]) ws[cellRef].s = cellStyle;
      });
    });

    /* ------------------ HEADER TEXT ------------------ */
    const cityName =
      props?.user?.role === "2"
        ? getCityName(props.user.cityId)
        : getCityName(selectCity ? selectCity : props?.user?.cityId);
    const stateName = props?.user?.role === "2" ? districtName : "";
    const headerData =
      props?.user?.role === "2" ? `${stateName} (${cityName})` : cityName;

    ws["A1"] = { v: headerData, t: "s", s: titleStyle };
    ws["A2"] = { v: ReportTitle, t: "s", s: subTitleStyle };

    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
    ];

    /* ------------------ FOOTER ------------------ */
    const footerRowIndex = exportData.length + HEADER_ROW + 3;

    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          `Generated At ${moment().format(
            "DD MMM YYYY",
          )} From Criminal Monitoring Intelligent System`,
        ],
      ],
      { origin: `A${footerRowIndex}` },
    );

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    ws["!merges"].push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
    });

    /* ------------------ ROW HEIGHT ------------------ */
    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][0] = { hpt: 40 };
    ws["!rows"][footerRowIndex - 1] = { hpt: 35 };

    /* ------------------ EXPORT ------------------ */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  const openAlbum = async (criminal) => {
    try {
      const res = await adminService.generateAlbumId();

      const crimeAlbumid = res.album_unique_id;

      console.log("crimeAlbumid", crimeAlbumid);

      // Now use it safely here
      downloadCriminalAlbumHTML(crimeAlbumid, criminal);
    } catch (error) {
      console.error(error);
    }
  };
  const downloadCriminalAlbumHTML = (crimeAlbumid, criminal) => {
    console.log("props.professionals", props.professionals);
    const role = props.user.role;

    let criminals = criminal.filter((crim) => crim.photo && crim.photo !== "");

    const cityName =
      role === "2"
        ? `${districtName}(${getCityName(props.user.cityId)})`
        : getCityName(props.user.cityId);

    let list_type = condition;

    const districts = props.professionals.basicDistricts || [];
    console.log("districts", districts);
    let paramter = {
      search_type: "wanted",
      list_type: condition,
      cityName: cityName,
    };
    const temp = {
      user_id: props.user.id,
      parameter: paramter,
      album_id: crimeAlbumid,
    };
    adminService.crimeAlbumLog(temp).then((res) => {
      console.log("res", res);
    });
    if (crimeAlbumid) {
      const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8" />
 <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
<title>Criminal Digital Album</title>

<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/moment@2.29.4/moment.min.js"></script>
<style>
    html {
      display: block;
    }

    footer {
      margin-top: auto;
      /* Push footer to bottom */
    }

    * {
      font-family: "Noto Sans Devanagari", sans-serif;
    }

    body {
      background: #f4f6fb;
    }

    footer {
      margin-top: 30px;
      padding: 14px 16px;
      text-align: center;
      background: white;
      border-top: 1px solid #e5e7eb;
      font-size: 14px;
      color: #555;
    }

    .footer-content {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
    }

    footer a {
      color: #1677ff;
      text-decoration: none;
      font-weight: 600;
    }

    footer a:hover {
      text-decoration: underline;
    }

    /* HEADER */
    .header-bar {
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      background: linear-gradient(135deg, #1e3a8a, #2563eb);
      color: white;
      padding: 18px 24px;
      border-radius: 14px;
      margin: 16px;
      box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
      position: relative;
    }

    /* TRUE CENTER ALIGNMENT */
    .header-center {
      text-align: center;
      justify-self: center;
      width: 100%;
    }

    /* RIGHT LOGO */
    .header-right {
      justify-self: end;
    }


    /* GOVERNMENT STYLE TEXT */
    .animated-text {
      display: inline-block;
      font-size: 17px;
      font-weight: 700;
      margin-top: 6px;
      color: #e0f2fe;
      letter-spacing: 0.4px;
      animation: glow 2.2s infinite alternate;
    }

    /* Glow animation */
    @keyframes glow {
      from {
        text-shadow: 0 0 4px #60a5fa, 0 0 10px #2563eb;
        transform: scale(1);
      }

      to {
        text-shadow: 0 0 10px #93c5fd, 0 0 18px #3b82f6;
        transform: scale(1.02);
      }
    }

    /* RIGHT LOGO */
    .header-right {
      display: flex;
      justify-content: flex-end;
    }

    .header-right img {
      max-height: 70px;
      border-radius: 10px;
      background: white;
      padding: 6px;
      border: 1px solid gold;
      transition: transform 0.3s ease;
    }

    .header-right img:hover {
      transform: scale(1.05);
    }


    /* Responsive */
    @media (max-width: 768px) {
      .header-bar {
        grid-template-columns: 1fr;
        text-align: center;
        gap: 10px;
      }

      .header-left,
      .header-right {
        justify-content: center;
      }

      .filter-box {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
      }

      .filter-box .count {
        margin-left: 0;
        align-self: flex-end;
        /* right align count */
      }
    }


    /* FILTER TAGS */
    .filter-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 14px;
      font-size: 14px;
      background: white;
      padding: 12px 16px;
      border-radius: 12px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .06);
      margin: 0 16px 14px;
      flex-wrap: wrap;
      /* allow wrapping */
    }

    /* Left text inline */
    .filter-box span {
      font-weight: 600;
      color: #1e3a8a;
      white-space: nowrap;
    }

    /* Right total photos */
    .filter-box .count {
      margin-left: auto;
      font-weight: 700;
      color: #2563eb;
      white-space: nowrap;
    }


    /* FILTER BAR */
    .filter-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      background: white;
      padding: 12px 14px;
      border-radius: 10px;
      margin: 0 16px 18px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .06);
      flex-wrap: nowrap;
    }

    .filter-right {
      display: flex;
      gap: 12px;
      align-items: center;
    }



    .filter-bar input {
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid #d9d9d9;
      font-size: 14px;
      text-align: center;
      /* min-width: 200px; */
      /* height: 38px; */
    }


    /* GRID */
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      gap: 16px;
      margin: 0 16px;
    }

    /* CARD */
    .card {
      background: white;
      border-radius: 14px;
      overflow: hidden;
      border: 2px solid #e5e7eb;
      transition: .2s;
      border: 3px solid #d400ff;
    }

    .card:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 22px rgba(0, 0, 0, .12);
    }

    /* IMAGE */
    .image-wrap {
      position: relative;
    }

    .card img {
      width: 100%;
      height: 230px;
      object-fit: cover;

    }

    /* BADGE */
    .badge {
      position: absolute;
      top: 8px;
      right: 8px;
      background: #dc2626;
      color: white;
      font-weight: bold;
      font-size: 13px;
      padding: 4px 10px;
      border-radius: 20px;
    }

    /* INFO */
    .info {
      padding: 12px;
      font-size: 14px;
    }

    .name {
      font-size: 16px;
      font-weight: 700;
      color: #1e3a8a;
      margin-bottom: 6px;
    }

    /* PAGINATION */
    .pagination-wrapper {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin: 22px 16px;
      flex-wrap: wrap;
    }

    .pagination button {
      padding: 6px 12px;
      border-radius: 6px;
      border: 1px solid #d9d9d9;
      cursor: pointer;
    }

    .pagination button.active {
      background: #1677ff;
      color: white;
    }

    /* Compact AntD Multi Select */
    .antd-multiselect {
      min-width: 260px;
      position: relative;
    }

    #searchInput {
      min-width: 220px;
      border-radius: 4px;
      border: 2px solid #6b7280;
      background: #fff;
      padding: 8px 12px;
      min-height: 42px;
      font-weight: 600;
    }

    .modal-header {
      background: #f8fafc;
      border-bottom: 1px solid #e5e7eb;
    }

    .modal-title {
      font-weight: 600;
      color: #1e3a8a;
    }


    .antd-input {
      border-radius: 4px;
      border: 2px solid #6b7280;
      background: #fff;
      padding: 8px 12px;
      min-height: 42px;
      font-weight: 600;
    }

    /* Hover */
    .antd-input:hover {
      border-color: #1e3a8a;
    }

    /* Focus */
    .antd-input:focus-within {
      border-color: #1e3a8a;
      box-shadow: 0 0 0 2px rgba(30, 58, 138, .2);
    }


    .antd-tags {
      display: flex;
      align-items: center;
      gap: 4px;
      overflow: hidden;
    }

    .antd-tag {
      background: #f0f5ff;
      border: 1px solid #adc6ff;
      color: #1d39c4;
      padding: 3px 8px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }


    .antd-tag button {
      border: none;
      background: transparent;
      cursor: pointer;
      font-size: 12px;
      color: #666;
    }

    #districtSearch {
      border: none;
      outline: none;
      font-size: 13px;
      flex: 1;
      min-width: 80px;
      height: 22px;
    }

    /* Dropdown */
    .antd-dropdown {
      display: none;
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      right: 0;
      width: 100%;
      max-height: 260px;
      overflow-y: auto;
      background: white;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      box-shadow: 0 12px 28px rgba(0, 0, 0, .16);
      z-index: 9999;
      padding: 6px 0;
    }

    .antd-dropdown::-webkit-scrollbar {
      width: 6px;
    }

    .antd-dropdown::-webkit-scrollbar-thumb {
      background: #c7d2fe;
      border-radius: 10px;
    }


    /* Option Row */
    .antd-option {
      padding: 9px 12px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #f0f0f0;
      transition: background .15s ease, transform .05s ease;
      line-height: 1.4;
    }

    .antd-option.selected {
      background: #eef4ff;
      font-weight: 600;
    }


    .antd-option:last-child {
      border-bottom: none;
    }

    .antd-option:hover {
      background: #f5f8ff;
    }

    .antd-option input {
      transition: transform .08s ease;
    }

    .antd-option input:checked {
      transform: scale(1.1);
    }

    /* PREMIUM SLIDER MODE */
    /* PREMIUM SLIDER MODE */
    .slider {
      display: flex;
      justify-content: center;
      margin: 26px 16px;
    }

    /* Desktop Slider Card */
    .slider-card {
      width: 100%;
      max-width: 620px;
      background: white;
      border-radius: 18px;
      border: 3px solid #7c3aed;
      overflow: hidden;
      box-shadow: 0 14px 28px rgba(0, 0, 0, .18);
      transition: .3s ease;
    }

    /* Desktop Image */
    .slider-card img {
      width: 100%;
      height: 420px;
      object-fit: contain;
      background: #f9fafb;
      border-bottom: 1px solid #eee;
    }

    /* Info section */
    .slider-card .info {
      padding: 16px;
      font-size: 15px;
    }

    /* SLIDER CONTROLS */
    .slider-controls {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      gap: 14px;
      padding: 12px 16px;
      background: white;
      border-top: 1px solid #e5e7eb;
      box-shadow: 0 -6px 18px rgba(0, 0, 0, .08);
    }

    /* Slide Counter */
    .slider-controls span {
      text-align: center;
      font-weight: 700;
      color: #6d28d9;
      font-size: 14px;
    }

    /* Buttons */
    .slider-controls button {
      padding: 8px 16px;
      border-radius: 10px;
      border: 1px solid #ddd;
      background: #fafafa;
      color: #4f46e5;
      font-weight: 700;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      transition: all .18s ease;
    }

    /* Hover */
    .slider-controls button:hover {
      background: #4f46e5;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(79, 70, 229, .35);
    }

    .slider-btn {
      border: 2px solid #7c3aed;
      background: white;
      color: #7c3aed;
      padding: 10px 14px;
      border-radius: 12px;
      font-weight: 700;
      transition: .2s ease;
    }

    .slider-btn.primary {
      background: #7c3aed;
      color: white;
    }

    .slider-btn:hover {
      transform: scale(1.04);
      box-shadow: 0 4px 12px rgba(124, 58, 237, .35);
    }

    /* THUMBNAILS */
    .thumbnail-strip {
      display: flex;
      gap: 10px;
      padding: 12px;
      overflow-x: auto;
      background: #f8fafc;
      border-top: 1px solid #e5e7eb;
    }

    .thumbnail-strip img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      border-radius: 10px;
      cursor: pointer;
      opacity: 0.55;
      border: 2px solid transparent;
      transition: .2s ease;
    }

    .thumbnail-strip img.active {
      opacity: 1;
      border-color: #7c3aed;
      transform: scale(1.08);
    }

    /* ===== MOBILE FULL WIDTH MODE ===== */
    @media (max-width: 768px) {
      .filter-bar {
        flex-wrap: wrap;
      }

      .filter-right {
        flex-direction: column;
        width: 100%;
      }

      .antd-multiselect,
      #searchInput {
        min-width: 100%
      }

      .slider {
        margin: 10px 0;
        padding: 1rem;
      }

      .slider-card {
        width: 100%;
        border-radius: 0;
        border-top: 4px solid #7c3aed;
        border-bottom: 4px solid #7c3aed;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .12);
        display: flex;
        flex-direction: column;
      }

      /* Image auto height — NO vh */
      .slider-card img {
        width: 100%;
        height: auto;
        max-height: 520px;
        object-fit: contain;
        background: #000;
      }

      .slider-card .thumbnail-strip img {
        width: 60px;
        height: 60px;
        max-height: auto;
      }

      .slider-card .info {
        padding: 14px 16px;
        font-size: 15px;
      }

      .slider-controls {
        padding: 12px;
        background: white;
        border-top: 1px solid #e5e7eb;
      }

      .thumbnail-strip {
        padding-bottom: 12px;
      }
    }





    .view-toggle-wrap {
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 600;
      white-space: nowrap;
    }


    /* ANT STYLE SWITCH */
    .antd-switch {
      position: relative;
      display: inline-block;
      width: 46px;
      height: 24px;
    }

    .antd-switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider-round {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #d9d9d9;
      transition: 0.25s;
      border-radius: 50px;
    }

    .slider-round:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: 0.25s;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    .antd-switch input:checked+.slider-round {
      background-color: #1677ff;
    }

    .antd-switch input:checked+.slider-round:before {
      transform: translateX(22px);
    }

    /* MOBILE */

    @media (max-width: 768px) {
      .header-bar {
        display: flex !important;
        /* Override grid */
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
      }

      .header-center {
        order: 1;
        width: 100%;
      }

      .header-right {
        order: 2;
        width: 100%;
        display: flex;
        justify-content: center;
        /* Center logo */
      }

      .header-right img {
        max-height: 55px;
      }


    }
  </style>
</head>

<body>

 <div class="header-bar">
            <div class="header-center">
                <h2>
                    Digital Album <br>
                    <span class="animated-text">Criminal Monitoring Intelligent System</span>
                </h2>
            </div>

            <div class="header-right">
                <a href="https://www.criminalmis.in/" target="_blank">
                    <img src="https://pcimageupload.s3.amazonaws.com/pc_cmis_logo-1770633708525.jpeg">
                </a>
            </div>
        </div>
          <div 
  style="text-align:right; margin:10px; font-weight:700; color:#1e3a8a;" 
  id="criminal_id"
  data-album-id="${crimeAlbumid}">
  Album Reference ID: ${crimeAlbumid}
</div>


<div class="filter-box">
   ${
     cityName
       ? `<span><strong>${
           role == 2 ? "पोलिस ठाणे;" : "घटक"
         } :</strong> ${cityName}</span>`
       : ""
   }
  ${condition ? `<span><strong>प्रकार:</strong> ${condition} </span>` : ""}
  <div class="count">Total Photos: <strong>${criminals.length}</strong></div>
  
  
</div>

 <div class="filter-bar">

    <!-- LEFT -->
    <div class="view-toggle-wrap">
      <span id="viewLabel">Grid View</span>

      <label class="antd-switch">
        <input type="checkbox" id="viewToggle">
        <span class="slider-round"></span>
      </label>

      <span id="viewLabelRight">Slide View</span>
    </div>

    <!-- RIGHT -->
    <div class="filter-right">
      <div class="antd-multiselect" style="${role == 2 ? "display:none;" : ""}">
        <div class="antd-input" id="districtToggle">
          <div class="antd-tags" id="selectedTags"></div>
          <input type="text" id="districtSearch" placeholder="Police Station" />
        </div>

        <div class="antd-dropdown" id="districtList"></div>
      </div>

      <input type="text" id="searchInput" placeholder="Search Name..." />
    </div>

  </div>

<div id="pagesContainer"></div>

<div class="pagination-wrapper" id="paginationWrapper">
  <div class="pagination" id="pagination"></div>
  <select id="pageSizeSelect">
    <option value="50">50 / page</option>
    <option value="100">100 / page</option>
    <option value="150">150 / page</option>
  </select>
</div>

<!-- Image Preview Modal -->
<div class="modal fade" id="imageModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <!-- Header with Close Button -->
      <div class="modal-header py-2">
        <h6 class="modal-title">Image Preview</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-2 text-center">
        <img id="modalImage" src="" style="width:100%; border-radius:10px; max-height:75vh; object-fit:contain;" />
      </div>

    </div>
  </div>
</div>


 <footer>
    <div class="footer-content"><a href="https://www.criminalmis.in/" target="_blank"> www.criminalmis.in
      </a> </div>
  </footer>

<script>
const crimeAlbumId = document
  .getElementById("criminal_id")
  .dataset.albumId;

console.log(crimeAlbumId);
window.onload = function () {

  fetch("https://v2api.criminalmis.in/api/criminal/crime-album-access", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      album_id: crimeAlbumId,
      type:"वॉंटेड"
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log("Access log saved", data);
  })
  .catch(error => {
    console.error("Error logging access", error);
  });

};

let viewMode = "grid"; // grid | slider
let sliderIndex = 0;

let currentPage = 0;
let pageSize = 50;

const criminals = ${JSON.stringify(criminals)};
const districts = ${JSON.stringify(districts)};
const pagesContainer = document.getElementById("pagesContainer");
    const districtList = document.getElementById("districtList");
    const districtToggle = document.getElementById("districtToggle");
    const selectedTags = document.getElementById("selectedTags");
    const districtSearch = document.getElementById("districtSearch");

    function applyFilters() {
      const search = document.getElementById("searchInput").value.toLowerCase();

      filteredData = criminals.filter(c => {

        // Multi district filter
        const matchesDistrict =
          selectedDistricts.length === 0 ||
          selectedDistricts.includes(c.districtName);

        // Global criminal search filter
        const matchesSearch =
          !search ||
          Object.values(c)
            .join(" ")
            .toLowerCase()
            .includes(search);

        return matchesDistrict && matchesSearch;
      });

      currentPage = 0;
      renderPage();
      renderPagination();
    }

    let selectedDistricts = [];

    // Open dropdown
    districtToggle.addEventListener("click", () => {
      districtList.style.display = "block";
      districtSearch.focus();
    });

    // Close outside click
    document.addEventListener("click", (e) => {
      const clickedInside =
        districtToggle.contains(e.target) ||
        districtList.contains(e.target);

      if (!clickedInside) {
        districtList.style.display = "none";
      }
    });


    // Render options
    function renderOptions(filter = "") {
      districtList.innerHTML = "";

      districts
        .filter(d => d.DistrictName.toLowerCase().includes(filter.toLowerCase()))
        .forEach(d => {
          const div = document.createElement("div");
          div.className = "antd-option";

          const checked = selectedDistricts.includes(d.DistrictName);

          div.innerHTML = \`
        <input type="checkbox" \${checked ? "checked" : ""}>
        <span>\${d.DistrictName}</span>
      \`;

          div.addEventListener("click", (e) => {
            e.stopPropagation(); // 🔥 prevents dropdown close
            toggleDistrict(d.DistrictName);
          });


          districtList.appendChild(div);
        });
    }

    // Toggle select
    function toggleDistrict(name) {
      if (selectedDistricts.includes(name)) {
        selectedDistricts = selectedDistricts.filter(x => x !== name);
      } else {
        selectedDistricts.push(name);
      }

      renderTags();
      renderOptions(districtSearch.value);
      applyFilters();
    }

    // Render tags
    function renderTags() {
      selectedTags.innerHTML = "";

      const visible = selectedDistricts.slice(0, 2);
      const extraCount = selectedDistricts.length - visible.length;

      visible.forEach(name => {
        const tag = document.createElement("div");
        tag.className = "antd-tag";
        tag.innerHTML = \`
      \${name}
      <button onclick="removeDistrict('\${name}')">×</button>
    \`;
        selectedTags.appendChild(tag);
      });

      if (extraCount > 0) {
        const more = document.createElement("div");
        more.className = "antd-tag";
        more.innerText = \`+\${extraCount}...\`;
        selectedTags.appendChild(more);
      }
    }

    // Remove tag
    function removeDistrict(name) {
      selectedDistricts = selectedDistricts.filter(x => x !== name);
      renderTags();
      renderOptions();
      applyFilters();
    }

    // Search filter
    districtSearch.addEventListener("input", (e) => {
      renderOptions(e.target.value);
    });

    function openImageModal(src) {
      const modalImg = document.getElementById("modalImage");
      modalImg.src = src;

      const modal = new bootstrap.Modal(document.getElementById("imageModal"));
      modal.show();
    }


    function nextSlide() {
      sliderIndex++;
      if (sliderIndex >= filteredData.length) sliderIndex = 0;
      renderPage();
    }

    function prevSlide() {
      sliderIndex--;
      if (sliderIndex < 0) sliderIndex = filteredData.length - 1;
      renderPage();
    }





    function enableSwipe() {
      const card = document.getElementById("sliderCard");
      if (!card) return;

      let startX = 0;

      card.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });

      card.addEventListener("touchend", (e) => {
        let endX = e.changedTouches[0].clientX;
        let diff = startX - endX;

        if (diff > 60) nextSlide();      // swipe left
        if (diff < -60) prevSlide();     // swipe right
      });
    }

    document.getElementById("viewToggle").addEventListener("click", () => {
      viewMode = viewMode === "grid" ? "slider" : "grid";
      sliderIndex = 0;

      document.getElementById("viewToggle").innerText =
        viewMode === "grid" ? "Switch to Slide View" : "Switch to Normal View";

      // Show pagination ONLY in grid mode
      document.getElementById("paginationWrapper").style.display =
        viewMode === "grid" ? "flex" : "none";

      renderPage();
    });


    function renderThumbnails() {
      const strip = document.getElementById("thumbnailStrip");
      if (!strip) return;

      strip.innerHTML = "";

      filteredData.forEach((item, index) => {
        const thumb = document.createElement("img");
        thumb.src = \`https://pcimageupload.s3.ap-south-1.amazonaws.com/\${item.photo}\`;

        if (index === sliderIndex) {
          thumb.classList.add("active");
        }

        thumb.onclick = () => {
          sliderIndex = index;
          renderPage();
        };

        strip.appendChild(thumb);
      });
    }

    // Render only current page
    function renderPage() {
      pagesContainer.innerHTML = "";

      const start = currentPage * pageSize;
      const end = start + pageSize;
      const pageItems = filteredData.slice(start, end);

      // GRID MODE (DEFAULT)
      if (viewMode === "grid") {
        const grid = document.createElement("div");
        grid.className = "grid";
         pageItems.forEach(c => {
      let conditionHTML = "";

      if ("${condition}" === "पाहिजे") {
        conditionHTML = \`
          <p>पोलिस ठाणे (पाहिजे): \${c.policeSideNeed || "-"}</p>
          <p>कधी पासून पाहिजे: \${c.date_from ? moment(c.date_from).format("DD-MM-YYYY") : "-"}</p>
        \`;
      }
      else if ("${condition}" === "फरार") {
        conditionHTML = \`
          <p>पोलिस ठाणे (फरार): \${c.policeSideNeed || "-"}</p>
          <p>कधी पासून फरार: \${c.date_from ? moment(c.date_from).format("DD-MM-YYYY") : "-"}</p>
        \`;
      }
       else if ("${condition}" === "हिस्ट्री शिटर") {
        conditionHTML = \`
          <p>हिस्ट्री शिटर समाविष्ट दिनांक: \${c.history_date ? moment(c.history_date).format("DD-MM-YYYY") : "-"}</p>
        \`;
      }
      else if ("${condition}" === "तडीपार") {
        conditionHTML = \`
          <p>पोलिस ठाणे (कारवाई करणारे): \${c.action_taken_police_station}</p>
        \`;
      }

      const card = document.createElement("div");
      card.className = "card";

      card.innerHTML = \`
        <div class="image-wrap">
          <img src="https://pcimageupload.s3.ap-south-1.amazonaws.com/\${c.photo}" onclick="openImageModal(this.src)" />
          <div class="badge">एकुण गुन्हे: \${c.gunhaCount || c.totalCrimeCount}</div>
        </div>
        <div class="info">
          <div class="name">\${c.name || "-"}</div>
          <p><strong>CMIS ID:</strong> \${c.id || "-"}</p>
          \${conditionHTML}
          <p><strong>पोलिस ठाणे:</strong> \${c.districtName || "-"}</p>
        </div>
      \`;

      grid.appendChild(card);
    });

       
        pagesContainer.appendChild(grid);
        return;
      }

      // SLIDER MODE
      // SLIDER MODE
      const c = filteredData[sliderIndex];
      if (!c) return;
      let conditionHTML = "";

      if ("${condition}" === "पाहिजे") {
        conditionHTML = \`
        <p>पोलिस ठाणे (पाहिजे): \${c.policeSideNeed || "-"}</p>
        <p>कधी पासून पाहिजे: \${c.date_from ? moment(c.date_from).format("DD-MM-YYYY") : "-"}</p>
      \`;
      }
      else if ("${condition}" === "फरार") {
        conditionHTML = \`
        <p>पोलिस ठाणे (फरार): \${c.policeSideNeed || "-"}</p>
        <p>कधी पासून फरार: \${c.date_from ? moment(c.date_from).format("DD-MM-YYYY") : "-"}</p>
        \`;
      }
      else if ("${condition}" === "हिस्ट्री शिटर") {
        conditionHTML = \`
        <p>हिस्ट्री शिटर समाविष्ट दिनांक: \${c.history_date ? moment(c.history_date).format("DD-MM-YYYY") : "-"}</p>
        \`;
      }


      const slider = document.createElement("div");
      slider.className = "slider";

      slider.innerHTML = \`
  <div class="slider-card" id="sliderCard">

    <div class="image-wrap">
      <img src="https://pcimageupload.s3.ap-south-1.amazonaws.com/\${c.photo}" onclick="openImageModal(this.src)" />
      <div class="badge">एकुण गुन्हे: \${c.gunhaCount || c.totalCrimeCount || 0}</div>
    </div>
    

   

 

   <div class="info">
      <div class="name">\${c.name || "-"}</div>
      <p><strong>CMIS ID:</strong> \${c.id || "-"}</p>
      \${conditionHTML}
      <p><strong>पोलिस ठाणे:</strong> \${c.districtName || "-"}</p>
    </div>
    <div class="slider-controls">
      <button class="slider-btn" onclick="prevSlide()">⬅ Previous</button>
      <span style="font-weight:600">\${sliderIndex + 1} / \${filteredData.length}</span>
      <button class="slider-btn primary" onclick="nextSlide()">Next ➡</button>
    </div>

    <!-- THUMBNAILS -->
    <div class="thumbnail-strip" id="thumbnailStrip"></div>

  </div>
\`;
      pagesContainer.appendChild(slider);
      renderThumbnails();
      enableSwipe();
    };


    // Render pagination with Previous / Next
    function renderPagination() {
      const totalPages = Math.ceil(filteredData.length / pageSize);
      const pagination = document.getElementById("pagination");
      pagination.innerHTML = "";

      // PREVIOUS BUTTON
      const prevBtn = document.createElement("button");
      prevBtn.innerText = "Previous";
      prevBtn.disabled = currentPage === 0;
      prevBtn.onclick = () => {
        currentPage--;
        renderPage();
        renderPagination();
      };
      pagination.appendChild(prevBtn);

      // PAGE NUMBERS (LIMITED)
      const visiblePages = 5;
      let start = Math.max(0, currentPage - 2);
      let end = Math.min(totalPages, start + visiblePages);

      for (let i = start; i < end; i++) {
        const btn = document.createElement("button");
        btn.innerText = i + 1;
        btn.className = i === currentPage ? "active" : "";
        btn.onclick = () => {
          currentPage = i;
          renderPage();
          renderPagination();
        };
        pagination.appendChild(btn);
      }

      // NEXT BUTTON
      const nextBtn = document.createElement("button");
      nextBtn.innerText = "Next";
      nextBtn.disabled = currentPage >= totalPages - 1;
      nextBtn.onclick = () => {
        currentPage++;
        renderPage();
        renderPagination();
      };
      pagination.appendChild(nextBtn);
    }
    // Page size change
    document.getElementById("pageSizeSelect").addEventListener("change", (e) => {
      pageSize = parseInt(e.target.value);
      currentPage = 0;
      renderPage();
      renderPagination();
    });

    districtSearch.addEventListener("input", (e) => {
      renderOptions(e.target.value);
    });

    document.getElementById("searchInput").addEventListener("input", applyFilters);


    // Initial load
    filteredData = criminals;
    renderPage();
    renderPagination();
    renderOptions();


</script>

</body>
</html>
`;

      const blob = new Blob([html], { type: "text/html" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "criminal_album_wanted.html";
      link.click();
    }
  };

  const getNoticeExportRows = () => {
    const arrData = data;

    let list =
      showList === "count"
        ? arrData.map((data, index) => ({
            "अ.क्र.": index + 1,
            [condition === "फरार"
              ? "पोलिस ठाणे (फरार)"
              : condition === "हिस्ट्रीशिटर"
                ? t("police_station_required1")
                : condition === "तडीपार"
                  ? t("police_station_action_by")
                  : t("police_station_required")]: data.districtName,
            [t("total")]: data.crimeCount,
          }))
        : condition !== "तडीपार"
          ? arrData.map((data, index) => {
              const whenToPatrolColumn =
                condition === "हिस्ट्रीशिटर"
                  ? t("history_sheeter_entry_date")
                  : condition === "फरार"
                    ? t("when_to_patrol_absconding")
                    : t("when_to_patrol");

              const item = {
                "अ.क्र.": index + 1,
                [t("police_station_required")]: data.policeSideNeed,
                [t("name_of_the_accused")]: data.name,
                [t("accused_police_station")]: data.districtName,
              };

              if (condition !== "हिस्ट्रीशिटर") {
                item[t("current_status")] =
                  data.current_condition || data.currentcondition;
              }

              item[whenToPatrolColumn] = data.date_from
                ? moment(data.date_from).format("DD/MM/YYYY")
                : moment(data.current_condition_date).format("DD/MM/YYYY");

              item[t("total_crimes")] = data.totalCrimeCount || data.gunhaCount;

              item["फोटो"] =
                data?.photo && data.photo.length > 0 ? "हो" : "नाही";

              return item;
            })
          : arrData.map((data, index) => ({
              "अ.क्र.": index + 1,
              "आरोपीचे नाव": data.name,
              "आरोपीचे पोलिस ठाणे": data.districtName,
              "एकुण गुन्हे": data.totalCrimeCount || data.gunhaCount,
              फोटो: data?.photo && data.photo.length > 0 ? "हो" : "नाही",
            }));
    return list;
  };

  const download_pdf = async () => {
    const arrData = getNoticeExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = t("wanted");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;

    const heading =
      condition === "पाहिजे"
        ? t("required")
        : condition === "फरार"
          ? t("absconding")
          : condition === "हिस्ट्रीशिटर"
            ? t("history")
            : t("tadipar");

    const ReportTitle = `${heading}_${t("report")}`;

    const headerText = getReportHeaderText({
      user: props?.user,
      cityName: getCityName(props?.user?.cityId || ""),
      districtName: districtName,
    });

    try {
      await downloadReportPdf({
        headerText,
        reportTitle: ReportTitle,
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
    }
  };

  const downloadReport = (download) => {
    console.log("test", download);
    if (download == "excel") {
      download_csv();
    }
    if (download == "criminal_album") {
      openAlbum(data);
    }
    if (download == "pdf") {
      download_pdf();
    }
    // if (download == "pdf") {
    //   setLoading(true);
    //   const input = document.getElementById("pdf-content");
    //   setTimeout(() => {
    //     setLoading(true);
    //     html2canvas(input, { scale: 2 }).then((canvas) => {
    //       const imgData = canvas.toDataURL("image/png");
    //       const pdf = new jsPDF("p", "mm", "a4");
    //       const imgWidth = 190;
    //       const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //       // Increase the font size for the PDF
    //       const fontSize = 16;
    //       pdf.setFontSize(fontSize);

    //       // Calculate the max height for a single page based on the font size
    //       const pageHeight = 297; // A4 page height in mm
    //       const contentHeight = imgHeight;
    //       let yPosition = 10;

    //       // Add the image and handle multiple pages
    //       pdf.addImage(imgData, "PNG", 10, yPosition, imgWidth, imgHeight);

    //       // Check if content overflows the page height
    //       if (contentHeight > pageHeight - 20) {
    //         let pageCount = Math.ceil(contentHeight / (pageHeight - 20));
    //         for (let i = 1; i < pageCount; i++) {
    //           pdf.addPage();
    //           yPosition = 10;
    //           pdf.addImage(imgData, "PNG", 10, yPosition, imgWidth, imgHeight);
    //         }
    //       }

    //       pdf.save("Wanted.pdf");
    //     });

    //     setLoading(false);
    //     setVisible(false);
    //   }, 500);
    // }
  };
  let columns = {
    arophi_new_list: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      { title: "आरोपीचे नाव", dataIndex: "name", key: "name" },
      { title: "वय", dataIndex: "age", key: "age" },
      { title: "आरोपीचे पोलिस ठाणे", dataIndex: "age", key: "age" },
      {
        title: "एकुण गुन्हे",
        dataIndex: "gunhaCount",
        key: "gunhaCount",
      },
      {
        title: "सद्यस्थिती",
        dataIndex: "currentcondition",
        key: "currentcondition",
      },
      {
        title: "फोटो",
        dataIndex: "photoPresent",
        key: "photoPresent",
      },
    ],
  };

  let columnsToShow = columns?.arophi_new_list.map((col) => ({
    ...col,
    title: <span style={{ fontSize: "18px" }}>{col.title}</span>,
  }));
  console.log("data", data);
  useEffect(() => {
    if (download == "pdf") {
      setVisible(true);
    }
  }, [download]);
  useEffect(() => {
    props.dispatch(professionalAction.getCrimeTitle());
  }, []);

  useEffect(() => {
    if (["4", "9", "10"].includes(props.user.role)) {
      props.dispatch(
        professionalAction.getDistrict(props.user && props.user.cityId, 1),
      );
    }
  }, []);

  //

  const [isSearch, setIsSearch] = useState(false);
  const handleInputChange = () => {
    if (props.user.role == 4) {
      if (condition === "तडीपार") {
        getTadipaarByCity(condition, searchText);
      } else if (
        stationType === "accused" &&
        (condition === "पाहिजे" || condition === "फरार")
      ) {
        getWantedByAccusedCity(condition, searchText, selectDistrict, citySelected);
      } else {
        getWanted(condition, searchText);
      }
    }
    if (props.user.role == 2) {
      if (
        stationType === "accused" &&
        (condition === "पाहिजे" || condition === "फरार")
      ) {
        getWantedByAccusedDistrict(condition, searchText);
        return;
      }
      getWantedByDistrict(condition, searchText);
    }

    setIsSearch(true);
  };

  const Clear = () => {
    setPhotoStatus(null);
    setIsFilter(false);
    setSelectCity();
    setSelectDistrict([]);
    SetCitySelected(false);
    setTotal(0);
    setSerachText(null);
    getdata(condition, showList, [], "", false, null);
  };

  console.log("search text", searchText);
  return (
    <>
      {/* Search Input */}
      {/* <div
            style={{
              flex: "1 1 300px",
              minWidth: "250px",
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={(e) => {
                setSerachText(e.target.value);
              }}
              disabled={data.length == 0}
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              style={{ flex: "1", borderRadius: "6px" }}
              allowClear
            />
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <Button
                // disabled={!searchText}
                type="primary"
                className="modern-button modern-button-success"
                // onClick={(e) => {
                //   handleInputChange();
                // }}
                onClick={() => getdata()}
              >
                {t("find")}
              </Button>
              {isSearch ? (
                <Button
                  className="modern-button modern-button-danger"
                  onClick={(e) => {
                    Clear();
                  }}
                >
                  {t("clear")}
                </Button>
              ) : (
                ""
              )}
            </div>
          </div> */}
      <div
        style={{
          padding: "16px 20px",
          background: "#fff",
          borderRadius: "8px",
          border: "1px solid #f0f0f0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap", // ✅ responsive
              rowGap: "8px",
              width: "100%",
            }}
          >
            {/* CONDITION */}
            <Form form={form} initialValues={{ condition: "पाहिजे" }}>
              <Form.Item name="condition" style={{ marginBottom: 0 }}>
                <Select
                  style={{ width: 150 }}
                  onChange={setCondition}
                  placeholder="Select"
                >
                  <Option value="पाहिजे">{t("required")}</Option>
                  <Option value="फरार">{t("absconding")}</Option>
                  <Option value="हिस्ट्रीशिटर">{t("history")}</Option>
                  <Option value="गुंडा">गुंडा रजिस्टर</Option>
                  <Option value="तडीपार">तडीपार</Option>
                </Select>
              </Form.Item>
            </Form>

            {/* CITY & DISTRICT */}
            {props.user.role !== "2" && (
              <>
                <Select
                  value={selectCity}
                  style={{ width: 220, minWidth: 160 }}
                  placeholder="Select City"
                  onChange={onCityChange}
                  showSearch
                >
                  {cities.map((c) => (
                    <Option key={c.id} value={c.id}>
                      {c.City}
                    </Option>
                  ))}
                </Select>

                <Select
                  mode="multiple"
                  value={selectDistrict}
                  style={{ width: 300, minWidth: 200 }}
                  placeholder="Select Police Station"
                  disabled={!citySelected}
                  onChange={setSelectDistrict}
                  showSearch
                >
                  {district.map((d) => (
                    <Option key={d.id} value={d.id}>
                      {d.DistrictName}
                    </Option>
                  ))}
                </Select>
              </>
            )}

            {/* FIND */}
            <Button
              type="primary"
              onClick={() => {
                setIsFilter(true);
                getdata(condition, showList);
              }}
            >
              {t("find")}
            </Button>

            {/* EXCEL */}
            <Select
              value={download}
              onChange={setDownload}
              style={{ width: 120 }}
              disabled={!data.length}
            >
              <Option value="excel">{t("excel")}</Option>
              {["4", "9", "10", "2"].includes(props.user.role) &&
                showList === "list" && (
                  <Option key="criminal_album">डिजिटल अल्बम</Option>
                )}
              <Option value="pdf">PDF</Option>
            </Select>

            {/* DOWNLOAD */}
            <Button
              type="primary"
              disabled={!data.length}
              onClick={() => downloadReport(download)}
            >
              {t("download")}
            </Button>

            {/* CLOSE (ALWAYS RIGHT) */}
            <Button
              danger
              icon={<CloseCircleFilled />}
              onClick={props.closeWanted}
              style={{
                marginLeft:
                  String(props.user.role) === "2" &&
                  (condition === "पाहिजे" || condition === "फरार")
                    ? 0
                    : "auto",
                flexShrink: 0,
              }}
            />
          </div>
        </div>

        {/* Filter Box (Bottom Section) */}
        {/* 
        {filter && (
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",

              marginBottom: "20px",
            }}
          >
            {showList === "list" && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  alignItems: "center",
                  justifyContent: "space-between", // push items to edges
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <label style={{ fontWeight: "500" }}>Search:</label>
                  <Input
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSerachText(e.target.value)}
                    disabled={data.length === 0}
                    prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                    style={{ width: "300px", borderRadius: "6px" }}
                    allowClear
                  />
                </div>
              </div>
            )}

            <div style={{ textAlign: "right" }}>
              {(searchText ||
                photoStatus ||
                (selectDistrict.length > 0 && selectCity)) && (
                <Button
                  type="primary"
                  className="modern-button modern-button-success"
                  onClick={() => {
                    setIsFilter(true);
                    getdata(condition, showList);
                  }}
                >
                  {t("find")}
                </Button>
              )}

              {isFilter && (
                <Button
                  className="modern-button modern-button-danger"
                  onClick={(e) => {
                    Clear();
                  }}
                >
                  {t("clear")}
                </Button>
              )}
            </div>
          </div>
        )} */}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
          padding: "12px",
          background: "#f5f5f5",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {props.user.role != "2" && (
            <Button
              type={showList === "count" ? "primary" : "default"}
              icon={<BarChartOutlined />}
              style={{ minWidth: "120px" }}
              onClick={() => handleCondition("count")}
            >
              {t("statistics")}
            </Button>
          )}

          <Button
            type={showList == "list" ? "primary" : "default"}
            icon={<UnorderedListOutlined />}
            onClick={() => handleCondition("list")}
            style={{ minWidth: "120px" }}
          >
            {t("list")}
          </Button>
        </div>
        {(String(props.user.role) === "2" || isCityAdminRole) &&
          (condition === "पाहिजे" || condition === "फरार") && (
            <Radio.Group
              value={stationType}
              onChange={(e) => {
                const nextType = e.target.value;
                setStationType(nextType);
                setData([]);
                setDataBackup([]);
                setTotal(0);
                setPhotoCount(0);
                if (isCityAdminRole && showList === "count") {
                  getWantedCountByCity(citySelected, nextType);
                  return;
                }
                if (nextType === "accused") {
                  if (String(props.user.role) === "2") {
                    getWantedByAccusedDistrict(
                      condition,
                      searchText,
                      photoStatus,
                    );
                    return;
                  }
                  getWantedByAccusedCity(
                    condition,
                    searchText,
                    selectDistrict,
                    citySelected,
                    photoStatus,
                  );
                  return;
                }
                getWanted(
                  condition,
                  searchText,
                  selectDistrict,
                  citySelected,
                  photoStatus,
                );
              }}
            >
              <Radio value="accused">आरोपी च्या पो. स्टे निहाय आरोपी</Radio>
              <Radio value="crime">गुन्ह्या च्या पो. स्टे निहाय आरोपी</Radio>
            </Radio.Group>
          )}
      </div>

      <TableWanted
        data={data}
        key={data}
        allTotal={count}
        total={count}
        onViewAccusedForm={onViewAccusedForm}
        loading={loading}
        condition={condition}
        showList={showList}
        total_count={total}
        cityId={citySelected ? selectCity : props.user.cityId}
        role={props.user.role}
        photoCount={photoCount}
        handleAdvancedFilterPhotoChange={handleAdvancedFilterPhotoChange}
        advancedFilterPhoto={advancedFilterPhoto}
        stationType={stationType}

      />

      {/* {visible && (
        <div id="pdf-content" style={{ padding: 20, background: "#fff" }}>
          <Table
            columns={columnsToShow}
            dataSource={data}
            pagination={false}
            bordered
            style={{ fontSize: "18px" }}
          />
        </div>
      )} */}

      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={criminalViewModel}
        onOk={closeCriminalViewModel}
        onCancel={closeCriminalViewModel}
        width={95 + "%"}
      >
        <ViewFormModel
          professionals={props?.professionals}
          dataStates={props?.professionals}
        ></ViewFormModel>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedWanted = connect(mapStateToProps)(Wanted);
export { connectedWanted as WantedList };
